import React, { useContext, useState, useEffect } from 'react'
import { Field, Form, Formik } from 'formik';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-time-picker/dist/TimePicker.css';
import { VehicleContext } from '../../Context/VehicleContext';
import { getImages } from '../../Common/const';
import ValidationError from '../../Errors/ValidationError';
import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';

const BookAppointmentModal = ({ close }) => {
    const { submitContactForm, vehicleListSearch, vehicleDecode, validateVIN } = useContext(VehicleContext);
    const recaptchaRef = React.useRef();

    const [date, setDate] = useState(null);
    const generateTimes = () => {
        const times = [];
        let currentTime = new Date();
        currentTime.setHours(8, 0, 0);

        const endTime = new Date();
        endTime.setHours(17, 0, 0);

        while (currentTime <= endTime) {
            const formattedTime = currentTime.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            });
            times.push(formattedTime);
            currentTime.setMinutes(currentTime.getMinutes() + 30); // Increment by 30 minutes
        }
        return times;
    }
    const timeList = generateTimes();

    const validationSchema = Yup.object().shape({
        //service: Yup.string().required('Service is required'),
        //date: Yup.date().required('Preferred date is required'),
        //time: Yup.string().required('Preferred time is required'),
        year: Yup.string().required('Year is required'),
        make: Yup.string().required('Make is required'),
        model: Yup.string().required('Model is required'),
        mileage: Yup.string().required('Mileage is required'),
        first_name: Yup.string().required('First name is required'),
        last_name: Yup.string().required('Last name is required'),
        email: Yup.string().email('Invalid email').required('Email is required')
    });

    console.log(validationSchema);

    //const serviceTypes = ['Oil Change', 'Fuel Filter', 'Spark Plugs', 'Transmission', 'Brake Inspection', 'Air Filter', 'Timing Belt', 'Wheel Alignment', 'Cooling System', 'Shocks', 'Tire Rotation', 'Other'];

    const formikRef = React.useRef();

    const [vinData, setVinData] = useState(null);

    const onChangeVin = (e) => {

        if (validateVIN(e.target.value)) {
            getVINData(e.target.value);
        }

        formikRef.current.setFieldValue('vin', e.target.value);
    }

    const getVINData = async (vin) => {
        const response = await vehicleDecode(vin);

        if ('attributes' in response) {
            setVinData(response.attributes);

            formikRef.current.setFieldValue('year', response.attributes.Year);

            var data = await getVehicleYearData(response.attributes.Year);

            formikRef.current.setFieldValue('make', response.attributes.Make);

            var data = await getVehicleModels(response.attributes.Year, response.attributes.Make);

            formikRef.current.setFieldValue('model', response.attributes.Model);

        }
    }

    const [vehicleYears, setVehicleYears] = useState([]);
    const [vehicleMakes, setVehicleMakes] = useState([]);
    const [vehicleModels, setVehicleModels] = useState([]);
    const [vehicleTrims, setVehicleTrims] = useState([]);

    const [vehicleYearData, setVehicleYearData] = useState([]);

    useEffect(() => {

        if (!vehicleYears || vehicleYears.length === 0) {

            getVehicleYears();
        }
    }, []);

    const getVehicleYears = async () => {
        const data = await vehicleListSearch({ 'subject': 'year' });
        console.log(data);
        setVehicleYears(data);
    }

    const getVehicleYearData = async (year) => {
        const data = await vehicleListSearch({ 'subject': 'yeardata', 'year': year });
        console.log(data);

        setVehicleYearData(data);

        let makes = [];

        if ('makes' in data) {
            data['makes'].map((make, i) => {
                makes.push(make.name);
            });

            setVehicleMakes(makes);
        }
    }

    const getVehicleModels = async (year, make) => {
        console.log(year, make);

        if ('makes' in vehicleYearData) {

            let models = [];

            vehicleYearData['makes'].filter((item) => item.name == make).map((make, i) => {
                console.log(make);
                if ('models' in make) {
                    make['models'].map((model, j) => {
                        models.push(model.name);
                    })
                }
            });

            setVehicleModels(models);
        }
    }

    const getVehicleTrims = async (year,make,model) => {        
        console.log(year,make,model);

        if('makes' in vehicleYearData) {

            let trims = [];

            vehicleYearData['makes'].filter((item) => item.name == make).map((make,i) => {
                console.log(make);
                if('models' in make) {
                    make['models'].filter((item) => item.name == model).map((model,j) => {
                        if('trims' in model) {
                            model['trims'].map((trim,k) => {
                                trims.push(trim.name);
                            })
                        }
                    })
                }
            });

            setVehicleTrims(trims);
        }
    }

    const contactMethods = ['Call', 'Text', 'Email'];
    return (
        <>
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className='modal-title filter-modal-title eurostile text-uppercase text-center w-100 font-1-2em'>Book Appointment</h1>
                    <button className="sm-box-close" type="button" onClick={close}>
                        <img src={getImages('white-close.svg')} />
                    </button>
                </div>
                <div className="modal-body ss-pd">
                    <Formik
                        validationSchema={validationSchema}
                        innerRef={formikRef}
                        initialValues={{
                            first_name: '',
                            last_name: '',
                            email: '',
                            phone: '',
                            year: '',
                            make: '',
                            model: '',
                            trim: '',
                            mileage: '',
                            comment: '',
                            //date: '',
                            //time: '',
                            service_form: true,
                            contactmethod: [],
                        }}
                        onSubmit={async (values, { resetForm }) => {
                            const token = await recaptchaRef.current.executeAsync();
                            recaptchaRef.current.reset(); // Reset after use

                            values.token = token;

                            console.log(values);
                            const data = await submitContactForm(values);
                            close();

                            if (data.success) {
                                resetForm();
                                alert("Thank you for your submission. We'll be in touch soon!");
                            } else
                                alert("There was a problem with your submission");
                        }}
                    >
                        {({ values, setFieldValue, field, form, errors }) => (
                            <Form className="custom-form schedule-form row mlr-35" autoComplete="off">
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey="6LckXRIsAAAAAAiOe2UBkXy7Uy-ROdiueqrr4Lzk" // Replace with your actual site key
                                    size="invisible"
                                /> 
                                <Field type="hidden" name="service_form" value={true} />
                                <div className='xs-title fw-700 text-uppercase mb-4 col-12'>Contact Info</div>
                                <div className='col-md-6 form-group'>
                                    <div className='d-flex align-items-center justify-content-between mb-2'>
                                        <div className='cs-label mb-0'>First Name</div>
                                        <div className='cs-require'><span className='text-orange'>*</span> Required</div>
                                    </div>
                                    <Field type="text" name="first_name" className="form-control" />
                                    <ValidationError name="first_name" />
                                </div>
                                <div className='col-md-6 form-group'>
                                    <div className='d-flex align-items-center justify-content-between mb-2'>
                                        <div className='cs-label mb-0'>Last Name</div>
                                        <div className='cs-require'><span className='text-orange'>*</span> Required</div>
                                    </div>
                                    <Field type="text" name="last_name" className="form-control" />
                                    <ValidationError name="last_name" />
                                </div>
                                <div className='col-md-6 form-group'>
                                    <div className='d-flex align-items-center justify-content-between mb-2'>
                                        <div className='cs-label mb-0'>Email</div>
                                        <div className='cs-require'><span className='text-orange'>*</span> Required</div>
                                    </div>
                                    <Field type="text" name="email" className="form-control" />
                                    <ValidationError name="email" />
                                </div>
                                <div className='col-md-6 form-group'>
                                        <div className='cs-label mb-2'>Phone</div>
                                    <Field type="text" name="phone" className="form-control" />
                                </div>
                                <div className='col-12'><hr className='cs-hr' /></div>
                                <div className='xs-title fw-700 text-uppercase mb-4 col-12'>Vehicle Info</div>
                                <div className='col-md-6 form-group'>
                                    <div className='cs-label mb-2'>Vehicle Year</div>
                                    <Field as="select" name="year" className="form-control"
                                        onChange={(e) => { setFieldValue('year', e.target.value); getVehicleYearData(e.target.value); }}
                                    >
                                        <option value="">Select</option>
                                        {vehicleYears && vehicleYears.map((v, i) => (
                                            <option key={i} value={v}>
                                                {v}
                                            </option>
                                        ))}
                                    </Field>
                                    <ValidationError name="year" />
                                </div>
                                <div className='col-md-6 form-group'>
                                    <div className='cs-label mb-2'>Make</div>
                                    <Field as="select" name="make" className="form-control"
                                        onChange={(e) => { setFieldValue('make', e.target.value); getVehicleModels(values.year, e.target.value); }}
                                    >
                                        <option value="">Select</option>
                                        {vehicleMakes && vehicleMakes.map((v, i) => (
                                            <option key={i} value={v}>
                                                {v}
                                            </option>
                                        ))}
                                    </Field>
                                    <ValidationError name="make" />
                                </div>
                                <div className='col-md-6 form-group'>
                                    <div className='cs-label mb-2'>Model</div>
                                    <Field as="select" name="model" className="form-control"
                                        onChange={(e) => { setFieldValue('model',e.target.value); getVehicleTrims(values.year,values.make,e.target.value); }}
                                    >
                                        <option value="">Select</option>
                                        {vehicleModels.map((v, i) => (
                                            <option key={i} value={v}>
                                                {v}
                                            </option>
                                        ))}
                                    </Field>
                                    <ValidationError name="model" />
                                </div>
                                <div className='col-md-6 form-group'>
                                    <div className='cs-label mb-2'>Trim</div>
                                    <Field as="select" name="trim" className="form-control">
                                        <option value="">Select</option>
                                        {vehicleTrims && vehicleTrims.map((v, i) => (
                                            <option key={i} value={v}>
                                                {v}
                                            </option>
                                        ))}
                                    </Field>
                                </div>
                                <div className='col-md-6 form-group'>
                                    <div className='cs-label mb-2'>Mileage</div>
                                    <Field type="text" name="mileage" className="form-control" />
                                    <ValidationError name="mileage" />
                                </div>
                                <div className='col-12 form-group'>
                                    <div className='cs-label mb-2'>Comments</div>
                                    <Field
                                        name="comment"
                                        className="form-control h-101"
                                        as="textarea"
                                    />
                                </div>
                                <div className='col-12'><hr className='cs-hr' /></div>
                                {/*<div className='xs-title fw-700 text-uppercase mb-4 col-12'>Appointment Info</div>
                                <div className='col-md-6 form-group'>
                                    <div className='cs-label mb-2'>Date</div>
                                    <DatePicker
                                        selected={date}
                                        onChange={(val) => {
                                            setDate(val);
                                            setFieldValue('date', val);
                                        }}
                                        className="form-control w-100"
                                        dateFormat="MM-dd-yyyy"
                                        placeholderText="mm/dd/yy"
                                    />
                                    <ValidationError name="date" />
                                </div>
                                <div className='col-md-6 form-group'>
                                    <div className='cs-label mb-2'>Time</div>
                                    <Field as="select" name="time" className="form-control">
                                        <option value=''>Select</option>
                                        {timeList.map((time, index) => (
                                            <option key={index} value={time}>
                                                {time}
                                            </option>
                                        ))}
                                    </Field>
                                    <ValidationError name="time" />

                                </div>*/}
                                <div className='col-12 form-froup mt-4'>
                                    <div className='xs-title fw-700 text-uppercase mb-4'>preferred contact method</div>
                                    <div className='d-md-flex align-items-center'>
                                        {contactMethods.map((method) => (
                                            <div className="custom-checkbox location-checkbox contact-method-checkbox me-md-5 mb-md-0 mb-3 pe-3" key={method}>
                                                <Field
                                                    type="checkbox"
                                                    name="contactmethod"
                                                    value={method}
                                                    id={`method${method}`}
                                                />
                                                <label htmlFor={`method${method}`} className='w-100'>{method}</label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className='col-12 mt-5'>
                                    <div className='text-end'>
                                        <button type='submit' className='orange-white-btn font-1-2em fw-700 lg-btn text-uppercase d-inline-block w-240'>
                                            Send
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </>
    )
}

export default BookAppointmentModal